import { render } from "./Stap5.vue?vue&type=template&id=7a307994"
import script from "./Stap5.vue?vue&type=script&lang=js"
export * from "./Stap5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__